import React from 'react';
import { AppNotificationMarkAsRead } from '../../apis/Agency';
import { Paper } from '@mui/material';
import { Typography } from '@mui/material';

const NotificationCard = ({
  id,
  title,
  subtitle,
  description,
  time,
  status,
  indicator = true,
  titleLength = 50,
  subtitleLength = 80,
  setGlobalOpen,
  setGlobalNotification,
  reFetch = function () {}
}) => {
  const handleOpenNotification = () => {
    setGlobalNotification({
      title: title,
      description: description,
      time: time
    });
    setGlobalOpen(true);

    if (status) {
      AppNotificationMarkAsRead(id)
        .then(() => {
          reFetch();
        })
        .catch(er => {
          console.log(er);
        });
    }
  };

  const getPlainTextFromHTML = html => {
    if (!html) return '';
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || '';
  };

  const plainDescription = getPlainTextFromHTML(description);
  const truncatedDescription =
    plainDescription.length > 80
      ? plainDescription.slice(0, 80) + '...'
      : plainDescription;

  return (
    <Paper
      elevation={0}
      onClick={() => handleOpenNotification()}
      style={{
        border: '1px solid #f1f5f9',
        borderRadius: '16px',
        cursor: 'pointer',
        padding: '16px',
        backgroundColor: status ? '#f8fafc' : 'white',
        transition: 'all 0.2s ease'
      }}
      onMouseEnter={e => {
        e.currentTarget.style.backgroundColor = '#f8fafc';
        e.currentTarget.style.borderColor = '#e2e8f0';
        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.05)';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.backgroundColor = status ? '#f8fafc' : 'white';
        e.currentTarget.style.borderColor = '#f1f5f9';
        e.currentTarget.style.boxShadow = 'none';
      }}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start' }}>
        {indicator && status && (
          <div
            style={{
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              backgroundColor: '#2563eb',
              marginRight: '12px',
              marginTop: '6px',
              flexShrink: 0,
              boxShadow: '0 0 0 2px rgba(37, 99, 235, 0.2)'
            }}
          />
        )}

        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              marginBottom: '6px'
            }}
          >
            <Typography
              style={{
                fontWeight: status ? 600 : 500,
                fontSize: '15px',
                color: '#0f172a',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                maxWidth: '70%'
              }}
            >
              {title?.length > titleLength
                ? title.slice(0, titleLength) + '...'
                : title}
            </Typography>
            <Typography
              style={{
                fontSize: '12px',
                color: '#94a3b8',
                whiteSpace: 'nowrap',
                marginLeft: '12px',
                flexShrink: 0
              }}
            >
              {time}
            </Typography>
          </div>

          {subtitle && (
            <Typography
              style={{
                fontWeight: 500,
                fontSize: '13px',
                color: '#334155',
                marginBottom: '4px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}
            >
              {subtitle?.length > subtitleLength
                ? subtitle.slice(0, subtitleLength) + '...'
                : subtitle}
            </Typography>
          )}

          <Typography
            style={{
              fontSize: '13px',
              color: '#64748b',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
          >
            {truncatedDescription}
          </Typography>
        </div>
      </div>
    </Paper>
  );
};

export default NotificationCard;
